import { disconnect } from "~/modules/Router/Auth/utils/auth/disconnect";

export const disconnectAuth = () => {
  disconnect().then((result) => {
    if (result.ok) {
      window.location.reload();
    }
  });
};
